import { motion, AnimatePresence } from 'framer-motion';
import useTimeout from '../../hooks/useTimeout';
import './errorStrip.sass';

type ErrorStripComponent = {
  isShown: boolean;
  msg?: string;
  displayTime: number;
  onHide: (value: boolean) => void;
};

export default function ErrorStrip({ isShown, msg, displayTime, onHide }: ErrorStripComponent) {
  useTimeout(onHide, isShown ? displayTime : null);

  return (
    <AnimatePresence>
      {isShown && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="error-strip">
          {msg}
        </motion.div>
      )}
    </AnimatePresence>
  );
}
